import styled from "styled-components";

export const Wrapper = styled.div`
  .gGmhQv {
    padding: 49px 25px;
  }
  .form-wrapper {
    border-radius: 5px;
    background-color: #f7f8f9;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 17%);
    padding: 49px 52px;
    margin-top: -8px;
    position: relative;
  }
  .form-inner {
    max-width: 78%;
  }
  a {
    font-size: 15px;
    color: #005aa3;
  }
  .wd50 {
    width: calc(50% - 14px);
  }
  .bgWhite {
    background-color: #fff;
  }
  .Group {
    padding: 12px 20px;
    border-radius: 4px;
    span {
      background-color: #f7f8f9;
      padding: 5px 6px;
      margin-right: 6px;
      border-radius: 4px;
      color: #4f4f4f;
    }
  }
  .icon-attachment {
    max-width: 20px;
    display: flex;
    align-items: center;
    img {
      max-width: 100%;
    }
  }
  .refresh-button{
    display: block;
  }
`;
